document.addEventListener('DOMContentLoaded', function () {
  function getHeaderHeight() {
    var header = document.querySelector('#header-component, header, [id*="header"]');
    if (header) return header.offsetHeight;
    var cssVar = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height'));
    return cssVar || 80;
  }

  function shopRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function normalizePath(path) {
    var p = path || '/';
    if (p.length > 1 && p.charAt(p.length - 1) === '/') p = p.slice(0, -1);
    return p || '/';
  }

  function isHomepage() {
    var path = normalizePath(location.pathname);
    var root = normalizePath(shopRoot());
    return path === '/' || path === root;
  }

  function homeHashUrl(hash) {
    var root = shopRoot();
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + hash;
  }

  document.querySelectorAll('a[href*="#"]').forEach(function (anchor) {
    if (anchor.classList.contains('desal-nav-link')) return;

    anchor.addEventListener('click', function (e) {
      var href = this.getAttribute('href');
      if (!href) return;

      var hashIndex = href.indexOf('#');
      if (hashIndex === -1) return;

      var hash = href.substring(hashIndex);
      if (!hash || hash === '#') return;

      var target = document.querySelector(hash);

      if (!target && !isHomepage()) {
        e.preventDefault();
        window.location.assign(homeHashUrl(hash));
        return;
      }

      if (target && isHomepage()) {
        e.preventDefault();
        var offset = getHeaderHeight() + 40;
        var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
        history.pushState(null, '', hash);
      }
    });
  });

  function injectLogout() {
    var sa = document.querySelector('shopify-account');
    if (!sa || !sa.shadowRoot) return;
    var observer = new MutationObserver(function () {
      var dialog = sa.shadowRoot.querySelector('dialog, [role="dialog"]');
      if (!dialog) return;
      if (dialog.querySelector('.desal-logout')) return;
      var nav = dialog.querySelector('nav, [class*="menu"], [class*="actions"]');
      var target = nav || dialog;
      var btn = document.createElement('a');
      btn.href = '/account/logout';
      btn.className = 'desal-logout';
      btn.textContent = 'Log out';
      btn.style.cssText =
        'display:block;text-align:center;padding:0.7rem 1rem;margin:0.75rem 1rem;border:1px solid #E5E5E5;border-radius:8px;color:#1C1C1C;text-decoration:none;font-size:0.85rem;transition:all 0.2s';
      btn.addEventListener('mouseover', function () {
        btn.style.background = '#F5F5F5';
      });
      btn.addEventListener('mouseout', function () {
        btn.style.background = 'transparent';
      });
      target.appendChild(btn);
    });
    observer.observe(sa.shadowRoot, { childList: true, subtree: true });
  }
  injectLogout();
});
